// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2-Ee3","content":"Consent_content__3Hlj8","footer":"Consent_footer__18iT8"};